import React, { useEffect, useState } from 'react'
import CustomModal from 'src/components/configuracion/components/customModal'
import { dt } from 'src/utils/documentsI18n'
import { isModuleTcStatementAssignable } from '../hooks/useModuleTcStatementPicker'

export default function ModuleTcStatementPickerModal({
  open,
  participants = [],
  onConfirm,
  onCancel,
}) {
  const [selectedId, setSelectedId] = useState('')
  useEffect(() => {
    if (open) setSelectedId('')
  }, [open])
  const assignable = (participants || []).filter(isModuleTcStatementAssignable)
  const canConfirm = Boolean(selectedId)
  const allLocked =
    (participants || []).length > 0 && (participants || []).every((row) => row.isLocked === true)

  return (
    <CustomModal
      open={open}
      onClose={onCancel}
      title={dt('reconcile.moduleTcPickerTitle')}
      size="small"
      dimmer="blurring"
      cancelarLabel={dt('common.cancel')}
      confirmLabel={dt('common.apply')}
      confirmDisabled={!canConfirm}
      onConfirm={() => onConfirm(selectedId)}
      content={
        <>
          <p>{dt('reconcile.moduleTcPickerBody')}</p>
          <div className="ui form">
            {(participants || []).map((row) => {
              const id = row.statementId
              const label = `${row.cardLabel || ''} — ${row.periodKey || ''}`.trim()
              const locked = row.isLocked === true
              const snapshotIntact = row.hasIntactBankSnapshot === true
              const cupoCovered = row.hasOpenBankCupo === false
              const disabled = locked || snapshotIntact || cupoCovered
              const suffix = locked
                ? ` (${dt('reconcile.moduleTcPickerLocked')})`
                : snapshotIntact
                  ? ` (${dt('reconcile.moduleTcPickerBankReconciled')})`
                  : cupoCovered
                    ? ` (${dt('reconcile.moduleTcPickerCupoCovered')})`
                    : ''
              return (
                <div className="field" key={id}>
                  <div className="ui radio checkbox">
                    <input
                      type="radio"
                      name="module-tc-statement"
                      disabled={disabled}
                      checked={selectedId === id}
                      onChange={() => setSelectedId(id)}
                    />
                    <label>
                      {label}
                      {suffix}
                    </label>
                  </div>
                </div>
              )
            })}
          </div>
          {assignable.length === 0 && (
            <p>
              {allLocked
                ? dt('reconcile.moduleTcPickerAllLocked')
                : dt('reconcile.moduleTcPickerNoneAssignable')}
            </p>
          )}
        </>
      }
    />
  )
}
